import React, { useEffect, useState } from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { CgMenuRound } from "react-icons/cg";
import { IoMdLogOut } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Header = ({ isAuthPage, isSidebar, handleSidebar }) => {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const handleLogout = () => {
    Swal.fire({
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Logout",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user-type");
        navigate("/");
      }
    });
  };

  const handleScroll = () => {
    setIsSticky(window.scrollY > 100); // Set threshold for when the header becomes sticky
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About" },
    { path: "/events", label: "Events" },
    { path: "/contact-us", label: "Contact Us" },
    { path: "/suggestion", label: "Suggestion" },
    { path: "/photo", label: "Photos" },
    { path: "/registration", label: "Member" },
  ];

  const renderNavLinks = () => {
    return navItems.map(({ path, label }) => (
      <Nav.Link
        key={path}
        as={Link}
        to={path}
        className={location.pathname === path ? "active" : ""}
        onClick={() => setExpanded(false)}
      >
        {label}
      </Nav.Link>
    ));
  };

  return (
    <header className={`header ${isSticky && isAuthPage ? "sticky" : ""}`}>
      <Navbar expand="lg" className="pt-0 mt-0 d-inline" expanded={expanded}>
        <Container className="px-4">
          <Navbar.Brand href="/" className="logo d-flex align-items-center">
            <img
              src="../assets/images/logo.png"
              alt="Logo"
              className="mt-1 d-sm-block d-none"
            />
            <h5 className="mb-0 ms-2 d-flex align-items-center">
              <div>
                <div className="d-flex align-items-center">
                  <span className="d-block text-orange me-1 fw-bold">
                    Saryuparin
                  </span>
                  Brahman Samaj
                </div>
                <span className="d-block short-name">Rajasthan, Jaipur</span>
              </div>
            </h5>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded((prev) => !prev)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto pt-0">{renderNavLinks()}</Nav>
          </Navbar.Collapse>

          {token && isSidebar ? (
            <Button
              className="px-2 bg-orange border-0 mb-3 ms-auto d-lg-none d-block header-button"
              onClick={() => handleSidebar()}
            >
              <CgMenuRound className="fs-3" />
            </Button>
          ) : (
            ""
          )}

          {token ? (
            <Button
              className="bg-orange border-0 text-white fw-bold header-btn"
              onClick={handleLogout}
            >
              <span className="d-sm-block d-none">Logout</span>
              <IoMdLogOut className="d-sm-none d-block" />
            </Button>
          ) : (
            <Link
              to="/login"
              className={`ms-lg-3 header-btn text-decoration-none fw-bold ${
                location.pathname === "/achievers"
                  ? "text-black"
                  : "text-orange"
              }`}
            >
              Login <i className="bi bi-arrow-right"></i>
            </Link>
          )}
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
